<div class="modal-overlay" (click)="close()">
  <div class="admin-modal" style="width: 960px;" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Copy Activity User Access</h3>
      <div class="header-actions">
        <i class="fa fa-minus-square-o" style="margin-right: 10px; cursor: pointer;" title="Minimize" (click)="close()"></i>
        <i class="fa fa-times" style="cursor: pointer;" title="Close" (click)="close()"></i>
      </div>
    </div>
    <div class="modal-body">
      <div class="copy-access-layout">
        <!-- Left panel: Source Activities tree -->
        <div class="source-activities-panel">
          <div class="panel-title">Source Activities</div>
          <div class="activity-tree-scroll">
            @for (task of sourceTree; track $index) {

              <div class="tree-task-row">
                <i class="fa fa-folder-open tree-task-icon"></i>
                <span class="tree-task-name">{{ task.task_name }}</span>
              </div>
              <div class="tree-activity-list">
                @for (activity of task.activities; track $index) {
<div class="tree-activity-row"
                    
                     [ngClass]="{'tree-activity-selected': activity.activity_key === selectedSourceActivityKey}"
                     (click)="selectSourceActivity(activity)">
                  <span class="tree-connector"></span>
                  <span class="activity-status-icon"
                        [ngClass]="{
                          'status-active': activity.activity_status === 'A',
                          'status-maintenance': activity.activity_status === 'M',
                          'status-locked': activity.activity_status === 'L',
                          'status-removed': activity.activity_status === 'R'
                        }">{{ activity.activity_status }}</span>
                  <span class="tree-activity-name">{{ activity.activity_name }}</span>
                  @if (activity.roles?.length) {
<span class="tree-role-badge">{{ activity.roles.length }}</span>
}
                </div>
}
              </div>
            
}
            @if (sourceTree.length === 0) {
<div class="no-data-msg">No source activities available.</div>
}
          </div>
        </div>

        <!-- Right side: Source + Target role panels -->
        <div class="role-panels">
          <div class="role-panels-row">
            <div class="role-panel source-role-panel">
              <div class="role-panel-title">Source</div>
              @if (sourceActivityName) {
<div class="role-panel-subtitle">{{ sourceActivityName }}</div>
}
              <div class="role-panel-body">
                @if (sourceRolesList.length === 0) {
<div class="no-roles-msg">No roles to display.</div>
}
                @for (role of sourceRolesList; track $index) {
<div class="role-radio-row">
                  <label class="radio-label">
                    <input type="radio" name="sourceRole" [value]="role"
                           [(ngModel)]="selectedSourceRole" [ngModelOptions]="{standalone: true}">
                    {{ role }}
                  </label>
                </div>
}
              </div>
            </div>

            <div class="role-panel target-role-panel">
              <div class="role-panel-title">Target</div>
              <div class="role-panel-subtitle">{{ targetActivityName }}</div>
              <div class="role-panel-body">
                @if (targetRolesList.length === 0) {
<div class="no-roles-msg">No roles to display.</div>
}
                @for (role of targetRolesList; track $index) {
<div class="role-radio-row">
                  <label class="radio-label">
                    <input type="radio" name="targetRole" [value]="role"
                           [(ngModel)]="selectedTargetRole" [ngModelOptions]="{standalone: true}">
                    {{ role }}
                  </label>
                </div>
}
              </div>
            </div>
          </div>

          <div class="add-mapping-row">
            <button class="btn btn-primary btn-sm" type="button"
                    (click)="addRoleMapping()"
                    [disabled]="!selectedSourceRole || !selectedTargetRole">
              Add Mapping <i class="fa fa-arrow-down"></i>
            </button>
          </div>

          <div class="mapped-roles-section">
            <div class="mapped-roles-title">Mapped Roles</div>
            <div class="mapped-roles-body">
              @for (mappedRole of mappedRolesList; track $index; let i = $index) {
<span class="btn-group btn-group-xs" style="margin-right: 5px; margin-bottom: 4px;"
                   >
                <span class="btn btn-default">{{ mappedRole.name }}</span>
                <span class="btn btn-danger" ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Mapping" direction="top"
                      (click)="removeRoleMapping(i)"><i class="fa fa-times"></i></span>
              </span>
}
              @if (mappedRolesList.length < 1) {
<div class="no-mappings-msg">No mappings to display.</div>
}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-success btn-sm" type="button" (click)="saveCopyAccess()"
              [disabled]="mappedRolesList.length < 1">Save Mapping @if (saveMappingLoader) {
<i class="fa fa-spinner fa-spin"></i>
}</button>
      <button class="btn btn-danger btn-sm" type="button" (click)="clearCopyAccess()">Clear</button>
      <button class="btn btn-warning btn-sm" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
